import isEmpty from 'lodash/isEmpty';

import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import * as services from 'modules/appointmentsManagement/services/fetchAppintmentOrganizationConfig';
import createAction from './';

export const FETCH_APPOINTMENTS_ORGANIZATION_CONFIG = createAsyncAction(createAction('FETCH_APPOINTMENTS_ORGANIZATION_CONFIG'));

export const fetchAppointmentsOrganizationConfig = () => (dispatch, getState) => {
  if (!isEmpty(getState().appointmentsManagement.appointmentConfig.cancellationReasons)) return Promise.resolve();

  dispatch({ type: FETCH_APPOINTMENTS_ORGANIZATION_CONFIG.pending });

  const apiCallParams = {
    query: services.FETCH_APPOINTMENTS_ORGANIZATION_CONFIG,
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then((response) => {

      const { data: { getOrganizationConfigPartial: { appointmentConfig } } } = response;

      return dispatch({
        type: FETCH_APPOINTMENTS_ORGANIZATION_CONFIG.success,
        payload: {
          cancellationReasons: appointmentConfig.allowedCancellationReasonValuesList,
          allowedCancellationReasons: appointmentConfig.allowedCancellationReasonValues,
          priorityMethods: appointmentConfig.availablePriorityMethods,
          eligibilityCheck: appointmentConfig.eligibilityCheck,
          availableRequestSources: appointmentConfig.availableRequestSources,
        },
      });
    })
    .catch((err) => {
      dispatch(errorAction(FETCH_APPOINTMENTS_ORGANIZATION_CONFIG.failure, err));
      throw err;
    });
};
